import React, { useState, useEffect, useDebugValue } from 'react';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import axios from 'axios';
import SoldNfts from './SoldNfts';
import LikedNfts from './LikedNfts';
import PurchasedNfts from './PurchasedNfts';
import NftsContainer from './NftsContainer';
import CollectionNfts from './collectionNft';
import PromoCodesContainer from './PromoCodesContainer';
import apiConfig from '../../config/apiConfig';
import {
  query,
  doc,
  where,
  getDoc,
  getDocs,
  limit,
  startAfter,
  orderBy,
  collection,
} from 'firebase/firestore/lite';
// import apiConfig from '../../config/apiConfig'
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import NFTCouponsContainer from './NFTCouponsContainer';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function CollectionComponent() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div
        // className="collection_main_box  py-20"
        style={{ background: '#f69b07' }}
      >
        <div className="px-4 md:px-10 w-full collection_main_box_container container mx-auto">
          <div className="">
            <div className="flex flex-wrap text-center justify-center">
              <div className="w-full lg:w-6/12 px-4">
                <h1 className="head__text text-4xl font-semibold text-white collection_main_heading">
                  My Collection
                </h1>
                <p className="text-lg leading-relaxed mt-4 text-white">
                  Manage, Edit and Transfer your existing NFTs. View your liked
                  NFTs and other activities
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="collection-AntTabs">
        <div className="main center_container">
          <div className="container">
            <div className="w-full px-4">
              <div>
                <Box sx={{ width: '100%' }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      // variant="fullWidth"
                      variant="scrollable"
                      scrollButtons="auto"
                      className="bg-white"
                    >
                      <Tab
                        wrapped
                        label="NFTs Owned"
                        disableRipple
                        style={{
                          flex: 2,
                          flexGrow: 2,
                        }}
                        {...a11yProps(0)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="On Sale(Active)"
                        {...a11yProps(1)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Not Active"
                        {...a11yProps(2)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Pending"
                        {...a11yProps(3)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Rejected"
                        {...a11yProps(4)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Coupons"
                        {...a11yProps(5)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="NFT Sale Coupons"
                        {...a11yProps(6)}
                      />

                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Liked"
                        {...a11yProps(7)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Collections"
                        {...a11yProps(8)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Sold NFTs"
                        {...a11yProps(9)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Purchased NFTs"
                        {...a11yProps(10)}
                      />
                      <Tab
                        disableRipple
                        style={{
                          // margin: '0 5px',
                          flex: 2,
                          flexGrow: 2,
                        }}
                        wrapped
                        label="Redeemed NFTs"
                        {...a11yProps(11)}
                      />
                    </Tabs>
                  </Box>

                  <div
                    style={{ overflow: 'auto' }}
                    className="bg-white flex-auto py-4"
                  >
                    <TabPanel value={value} index={0}>
                      <NftsContainer type="owned" />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <NftsContainer type="active" />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <NftsContainer type="inactive" />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                      <NftsContainer type="pending" />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                      <NftsContainer type="rejected" />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                      <PromoCodesContainer />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                      <NFTCouponsContainer />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={7}>
                      <LikedNfts type="liked" />{' '}
                    </TabPanel>
                    <TabPanel value={value} index={8}>
                      <CollectionNfts />
                    </TabPanel>
                    <TabPanel value={value} index={9}>
                      <SoldNfts />
                    </TabPanel>
                    <TabPanel value={value} index={10}>
                      <PurchasedNfts />
                    </TabPanel>
                    <TabPanel value={value} index={11}>
                      <NftsContainer type="redeem" />{' '}
                    </TabPanel>
                  </div>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
